import PropTypes from 'prop-types';
import { Box, Card, CardContent, Chip, Typography } from '@mui/material';
import { LABEL_META, convStrength } from './shared';

const HeroCard = ({ avgConviction, count, desc, gradient, icon, stocksLabel, title }) => (
  <Card sx={{ flex: '1 1 0', minWidth: 180, background: gradient, color: 'white' }}>
    <CardContent sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 0.5 }}>
        <Typography sx={{ fontSize: '0.7rem', fontWeight: 600, opacity: 0.85 }}>{title}</Typography>
        <Box sx={{ opacity: 0.6, '& svg': { fontSize: 20 } }}>{icon}</Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75, mb: 0.5 }}>
        <Typography sx={{ fontSize: '1.8rem', fontWeight: 800, lineHeight: 1.2 }}>{count}</Typography>
        <Typography sx={{ fontSize: '0.65rem', opacity: 0.75 }}>{stocksLabel}</Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography sx={{ fontSize: '0.62rem', opacity: 0.7 }}>{desc}</Typography>
        {avgConviction != null && (
          <Chip
            label={convStrength(avgConviction).label}
            size="small"
            sx={{ height: 18, fontSize: '0.6rem', fontWeight: 700, bgcolor: 'rgba(255,255,255,0.25)', color: 'white' }}
          />
        )}
      </Box>
    </CardContent>
  </Card>
);

HeroCard.propTypes = {
  avgConviction: PropTypes.number,
  count: PropTypes.number,
  desc: PropTypes.string.isRequired,
  gradient: PropTypes.string.isRequired,
  icon: PropTypes.node,
  stocksLabel: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const HeroCardsSection = ({ byLabelMap, heroLabels, t }) => (
  <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
    {heroLabels.map((label) => {
      const meta = LABEL_META[label];
      const data = byLabelMap[label];

      return (
        <HeroCard
          key={label}
          avgConviction={data?.avg_conviction}
          count={data?.count || 0}
          desc={t(`behavior.labels.${label}.desc`)}
          gradient={meta.gradient}
          icon={meta.icon}
          stocksLabel={t('behavior.stocks')}
          title={t(`behavior.labels.${label}.title`)}
        />
      );
    })}
  </Box>
);

HeroCardsSection.propTypes = {
  byLabelMap: PropTypes.objectOf(PropTypes.shape({
    count: PropTypes.number,
    avg_conviction: PropTypes.number,
  })).isRequired,
  heroLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  t: PropTypes.func.isRequired,
};

export default HeroCardsSection;